module.exports = __webpack_public_path__ + "static/media/hero_bg.5e8eea13.png";